import { User as FirebaseUser } from 'firebase/auth'
import { SubscriptionStatus } from '../../services/api'

export interface User {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  subscription?: SubscriptionStatus;
}

export interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

export type AuthContextType = {
  user: User | null,
  loading: boolean,
  error: string | null,
  login: () => Promise<void>,
  logout: () => Promise<void>,
  isAuthenticated: boolean,
  checkSubscription: () => Promise<SubscriptionStatus | null>,
}

export const mapFirebaseUserToUser = (firebaseUser: FirebaseUser): User => ({
  uid: firebaseUser.uid,
  email: firebaseUser.email,
  displayName: firebaseUser.displayName,
  photoURL: firebaseUser.photoURL,
})
